import 'css-chunksrc/client/scenes/chatbot/styles.scss';export default {
  "chatbot": "_chatbot_k895z_1",
  "conversation": "_conversation_k895z_10",
  "header": "_header_k895z_17",
  "headerIcon": "_headerIcon_k895z_25",
  "headerTitle": "_headerTitle_k895z_30",
  "error": "_error_k895z_36"
};